import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/GearFine.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: n }));
o.displayName = "GearFineIcon";
const c = o;
export {
  c as GearFine,
  o as GearFineIcon
};
